import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {createBrowserRouter, RouterProvider } from 'react-router-dom';
import RootLayout from './Layouts/RootLayout' ;
import Home from './Page/Home/index';
import Analytics from './Page/Analytics';
import Documents from './Page/Documents';
import Settings from './Page/Settings';
import NotFound from './Page/NotFound';
import Login from './Page/Login';
import AdminPanel from './Page/AdminPanel';
import ProtectedRoute from './Components/ProtectedRoute';
import PublicRoute from './Components/PublicRoute';
import AdminRoute from './Components/AdminRoute';

import AppWrapper from './Layouts/AppWrapper';



const router = createBrowserRouter([
  {
    element: <AppWrapper />,
    children: [
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <RootLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true, // index: true means this is the default route for the parent route
            element: <Home />,
          },
          { path: 'analytics', element: <Analytics /> },
          { path: 'documents', element: <Documents /> },
          { path: 'settings', element: <Settings /> },
        ],
      },
      {
        path: '/admin',
        element: (
          <AdminRoute>
            <RootLayout />
          </AdminRoute>
        ),
        children: [
          {
            index: true,
            element: <AdminPanel />,
          },
        ],
      },
      {
        path: '/login',
        element: (
          <PublicRoute>
            <Login />
          </PublicRoute>
        ),
      },
      {
        path: '*',
        element: <NotFound />, // NotFound can also be a child of AppWrapper
      },
    ],
  },
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <RouterProvider router={router} />
  </React.StrictMode>
);

